import * as React from 'react';
import { Bem, addClass } from '../../utils';
import { useId } from '../../utils/hooks/useId';
import './AccordionList.css';
import { Key } from '../../constants';
const bem = Bem.create('vai-accordion-list');
export const AccordionList = React.forwardRef((props, ref) => {
    const { mode, children, htmlId, dataTa, summaryWidth, className, exclusive = true, defaultKeys = [], onChange } = props;
    const [activeKeys, setActiveKeys] = React.useState([].concat(defaultKeys).filter(Boolean));
    const id = useId(htmlId, ['accordion list']);
    let focusKey = React.useRef('').current;
    let buttonNodes = React.useRef([]).current;
    const onAccordionClick = React.useCallback((isExpanded, accordionKey) => {
        const k = accordionKey;
        if (activeKeys.includes(k)) {
            setActiveKeys(activeKeys.filter((key) => key !== k));
        }
        else {
            setActiveKeys(exclusive ? [k] : Array.from(new Set(activeKeys.concat(k))));
        }
        if (onChange) {
            onChange([...activeKeys], k, isExpanded);
        }
    }, [exclusive, activeKeys, onChange]);
    const handleKeyDown = React.useCallback((e) => {
        if (!focusKey || ![Key.Home, Key.End, Key.ArrowDown, Key.ArrowUp].includes(e.key)) {
            return;
        }
        const childrenArray = React.Children.toArray(children);
        if (childrenArray.length === 0) {
            return;
        }
        e.preventDefault();
        e.stopPropagation();
        const currentIndex = childrenArray.findIndex((child) => child.props.accordionKey === focusKey);
        const nextIndex = currentIndex < childrenArray.length - 1 ? currentIndex + 1 : 0;
        const prevIndex = currentIndex !== 0 ? currentIndex - 1 : childrenArray.length - 1;
        switch (e.key) {
            case Key.ArrowDown: {
                focusKey = childrenArray[nextIndex].props.accordionKey;
                buttonNodes[nextIndex].focus();
                return;
            }
            case Key.ArrowUp: {
                focusKey = childrenArray[prevIndex].props.accordionKey;
                buttonNodes[prevIndex].focus();
                return;
            }
            case Key.Home: {
                focusKey = childrenArray[0].props.accordionKey;
                buttonNodes[0].focus();
                return;
            }
            case Key.End: {
                focusKey = childrenArray[childrenArray.length - 1].props.accordionKey;
                buttonNodes[childrenArray.length - 1].focus();
                return;
            }
        }
        return;
    }, [children]);
    const accordions = React.useMemo(() => getValidChildren(children).map((child, index) => {
        const key = child.props.accordionKey || `accordion-${index.toString()}`;
        return React.cloneElement(child, {
            mode: mode || child.props.mode,
            htmlId: child.props.htmlId || id.copyWith([index.toString()]).toHtmlId(),
            accordionKey: key,
            title: child.props.title,
            summaryWidth: summaryWidth || child.props.summaryWidth,
            isExpanded: activeKeys.includes(key),
            onChangeAccordionExpanded: onAccordionClick,
            onAccordionFocus: (key) => (focusKey = key),
            _buttonRef: (el) => (buttonNodes[index] = el),
        });
    }), [children, mode, summaryWidth, activeKeys]);
    return (React.createElement("div", { id: id.toString(), "data-ta": dataTa, className: addClass(bem.block(), className), onKeyDown: handleKeyDown, ref: ref }, accordions));
});
function getValidChildren(children) {
    return React.Children.toArray(children).filter((child) => React.isValidElement(child));
}
//# sourceMappingURL=AccordionList.js.map